import React from 'react'
import { DrillsLoader } from 'loaders'
import PropTypes from 'prop-types'
import TrainingPackageCreateContainer from './TrainingPackageCreateContainer'

const TrainingPackageCreate = ({ history, match, location }) => (
  <DrillsLoader>
    <TrainingPackageCreateContainer {...{ history, match, location }} />
  </DrillsLoader>
)

TrainingPackageCreate.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({}).isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,

  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
}

export default TrainingPackageCreate
